var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChipMacauNumber(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.48302 19.2964C5.28288 19.2964 4.21319 19.069 3.26277 18.6181C2.31607 18.1671 1.56319 17.5446 1.01157 16.7545C0.456227 15.9643 0.161783 15.0586 0.124512 14.0411H3.35968C3.41931 14.7977 3.7473 15.4127 4.33991 15.8898C4.93253 16.3669 5.64814 16.6054 6.4793 16.6054C7.13155 16.6054 7.71298 16.4563 8.2236 16.1544C8.73422 15.8562 9.13303 15.4388 9.42747 14.9058C9.72192 14.3728 9.86355 13.7653 9.85982 13.0795C9.86728 12.3863 9.71819 11.7676 9.42002 11.2271C9.12185 10.6867 8.70813 10.2618 8.19006 9.95617C7.66826 9.64682 7.06819 9.49401 6.39357 9.49401C5.84196 9.48655 5.30152 9.59091 4.76481 9.79963C4.23183 10.0084 3.80693 10.2842 3.49758 10.6271L0.486045 10.1313L1.44765 0.638306H12.1297V3.42621H4.20947L3.68021 8.30877H3.7883C4.1312 7.90624 4.612 7.57453 5.23443 7.30617C5.85686 7.03782 6.54266 6.90737 7.28436 6.90737C8.39878 6.90737 9.39393 7.16827 10.2698 7.6938C11.1457 8.21932 11.8352 8.93866 12.3384 9.85554C12.8415 10.7724 13.095 11.8197 13.095 13.0013C13.095 14.1828 12.8154 15.3009 12.2527 16.2513C11.6936 17.2017 10.9146 17.9472 9.92318 18.4913C8.93176 19.0355 7.7838 19.3039 6.48302 19.3039V19.2964Z",
    fill: "url(#paint0_linear_3716_18326)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3716_18326",
    x1: 6.60975,
    y1: 22.2669,
    x2: 6.60975,
    y2: -8.25467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#291419"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#462B2B"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChipMacauNumber);
export default __webpack_public_path__ + "static/media/chip-macau-number.31fd9c088b44ab661e29dab8234903a8.svg";
export { ForwardRef as ReactComponent };